import { StyledEndAdornment } from './StyledEndAdornment';
import { StyledStartAdornment } from './StyledStartAdornment';
import { jsx as _jsx } from "react/jsx-runtime";
export const Adornment = _ref => {
  let {
    adornmentType,
    adornment,
    clearButton,
    onClearButton,
    size,
    disabled,
    value
  } = _ref;
  if (adornmentType === 'end') {
    return /*#__PURE__*/_jsx(StyledEndAdornment, {
      clearButton: clearButton,
      onClearButton: onClearButton,
      adornment: adornment,
      size: size,
      disabled: disabled,
      adornmentType: adornmentType,
      value: value
    });
  }
  if (adornmentType === 'start') {
    return /*#__PURE__*/_jsx(StyledStartAdornment, {
      adornment: adornment,
      size: size,
      disabled: disabled,
      adornmentType: adornmentType
    });
  }
  return null;
};